import moment from "moment";

// Get visible note

export default (files) => {
  return files.sort((a, b) => {
    return a.createAt < b.createAt ? 1 : -1;
  });
};
